import DateTimeInput from '@component/DateTimeInput';
import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import { formatLocalDateTime, formatTimeWithSeconds } from '@utils/date.utils';
import {
  ChallengeFormComponent,
  ChallengeFormType,
} from '../../NewChallengeForm.types';
import {
  convertData2Form,
  convertForm2Data,
} from './PurchaseEndDateForm.serializer';
import {
  usePurchaseDateTime,
  usePurchaseEndDateTimeActions,
} from './PurchaseEndDateForm.store';
import { validate } from './PurchaseEndDateForm.validator';
import { useEditCheck } from '../../hooks/useEditCheck';

const PurchaseEndDateForm: ChallengeFormComponent<
  Pick<ChallengeInfoForAdmin, 'purchaseEndDate'>,
  Pick<ChallengeFormType, 'purchaseEndDate'>,
  Pick<ReqCreateOrUpdateChallenge, 'purchaseEndDate'>
> = () => {
  const { purchaseStartDate, purchaseEndDate } = usePurchaseDateTime();

  const { setPurchaseEndDateTime } = usePurchaseEndDateTimeActions();

  const validated = validate({ purchaseStartDate, purchaseEndDate });

  const { getBorder, triggerEdited } = useEditCheck();

  const handleChange = (value: string) => {
    if (!value.length) return;

    triggerEdited('purchaseEndDate');
    setPurchaseEndDateTime(formatTimeWithSeconds(new Date(value)));
  };

  return (
    <DateTimeInput
      label="구매일시 (종료)"
      value={purchaseEndDate || formatLocalDateTime(new Date())}
      errorMsg={validated.isValid ? '' : validated.message}
      onChange={handleChange}
      style={{ border: getBorder('purchaseEndDate') }}
    />
  );
};

export default PurchaseEndDateForm;

PurchaseEndDateForm.validate = validate;
PurchaseEndDateForm.convertData2Form = convertData2Form;
PurchaseEndDateForm.convertForm2Data = convertForm2Data;
